import React, { FC } from 'react'
import OnboardingStepTemplate from './OnboardingStepTemplate'

interface Props {
  phaseNum: number
  numPhases: number
  onNext: () => void
}
const OnboardingIntroDialog: FC<Props> = (props) => {
  const { phaseNum, onNext, numPhases } = props

  return (
    <OnboardingStepTemplate
      phaseNum={phaseNum}
      numPhases={numPhases}
      heading={`We understand why you left them open: to easily access them later without forgetting.`}
      buttonText={`Next`}
      onButtonClick={onNext}
      delayButtonActivation={false}
    />
  )
}
export default OnboardingIntroDialog
